module.exports = __webpack_public_path__ + "assets/img/sabc_livecenter_rightarrow.webp?603c70605687c6af4cca6e2fbd78effa";